<template>
  <ToggleSwitch
    v-model="plantAsTabs"
    @change="changePlantAsTabs"
    name="plant-as-tabs-switch"
  />
</template>
<script lang="ts">
import { useUiStore } from '@/stores/UiStore.ts';

export default {
  name: 'plant-as-tabs-switch',
  data() {
    return {
      plantAsTabs: null,
    };
  },
  mounted() {
    this.plantAsTabs =
      useUiStore().singlePlantViewType === 'tabs' ||
      useUiStore().singlePlantViewType === null;
  },
  methods: {
    changePlantAsTabs() {
      useUiStore().setSinglePlantViewType(
        this.plantAsTabs ? 'tabs' : 'accordion',
      );
    },
  },
};
</script>
